export function isObject(obj: any): obj is Record<keyof any, any> {
  return Object.prototype.toString.call(obj) === '[object Object]'
}
export function isArray(arr: any): arr is any[] {
  return Object.prototype.toString.call(arr) === '[object Array]'
}

export function isDate(obj: any) {
  return Object.prototype.toString.call(obj) === '[object Date]'
}

export function isNumber(obj: any) {
  return typeof obj === 'number'
}

export function isBoolean(obj: any) {
  return typeof obj === 'boolean'
}

export function isString(obj: any) {
  return typeof obj === 'string'
}

export function isFunction(obj: any) {
  return typeof obj === 'function'
}

export function isUndefined(obj: any) {
  return obj === void 0
}

export function isNull(obj: any) {
  return obj === null
}

export function typeForDisplay(obj: any) {
  if (typeof obj === 'number') {
    return 'Number'
  }
  if (typeof obj === 'boolean') {
    return 'Boolean'
  }
  if (typeof obj === 'string') {
    return 'String'
  }
  if (isArray(obj)) {
    return 'Array'
  }
  if (isDate(obj)) {
    return 'Date'
  }
  if (isObject(obj)) {
    return 'Object'
  }
  if (isUndefined(obj)) {
    return 'Undefined'
  }
  if (isNull(obj)) {
    return 'Null'
  }
  const type = Object.prototype.toString
    .call(obj)
    .slice(8, -1)
    .replace(/\s/g, '')
  return upperCaseFirst(type)
}

function upperCaseFirst(str: any) {
  if (!isString(str)) {
    return str
  }
  const first = str.slice(0, 1).toUpperCase()
  const rest = str.slice(1, str.length)
  return first + rest
}
